import { render, staticRenderFns } from "./ProxyManage.vue?vue&type=template&id=56e010e0&scoped=true&"
import script from "./ProxyManage.vue?vue&type=script&lang=js&"
export * from "./ProxyManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e010e0",
  null
  
)

export default component.exports